export const serialNum = (index) => {
  return index + 1 / 10 > 0 ? `0${index + 1}` : index
}

export const targetCategory = (gender, rootCategory, category) => {
  const str = [gender, rootCategory, category].filter(Boolean).join(' / ')
  return str
}

export const convert = (result) => {
  let count = 1
  const _convert = (arr, currentItem) => {
    return arr.map(item => {
      let parent = null
      item.label = item.name
      item.value = item.name
      if (currentItem) {
        parent = { label: currentItem.name, value: currentItem.name, node: count }
        count += 1
        item.parent = parent
      }
      _convert(item.children, item)
      return item
    })
  }
  return _convert(result)
}
